// Radha — Spanish (es-ES) locale pack.
// Shell chrome only: nav, header, repeated states and actions. Panel body
// copy is intentionally absent — it is finance/legal terminology that needs
// native review, and t() falls back to English until it is translated.
const es = {
  "nav.overview": "Resumen",
  "nav.collections": "Cobros",
  "nav.disputes": "Disputas",
  "nav.contracts": "Contratos",
  "nav.invoicing": "Facturación",
  "nav.recurring": "Recurrentes",
  "nav.statements": "Estados de cuenta",
  "nav.creditNotes": "Notas de crédito",
  "nav.gst": "Impuestos",
  "nav.tax": "Impuestos y e-factura",
  "nav.reconciliation": "Conciliación",
  "nav.deductions": "Deducciones",
  "nav.withholding": "Retenciones",
  "nav.cashflow": "Flujo de caja",
  "nav.crm": "CRM",
  "nav.forecasts": "Previsiones",
  "nav.reminders": "Recordatorios",
  "nav.dunning": "Reclamación",
  "nav.automation": "Automatización",
  "nav.settings": "Ajustes",
  "nav.privacy": "Privacidad",
  "group.receivables": "Cuentas por cobrar",
  "group.planning": "Planificación",
  "group.operations": "Operaciones",
  "group.admin": "Administración",
  "app.tagline": "Sistema operativo de ingresos",
  "app.signOut": "Cerrar sesión",
  "app.search": "Buscar",
  "app.toggleTheme": "Cambiar tema",
  "app.toggleNav": "Alternar navegación",
  "app.language": "Idioma",
  "app.useTenantDefault": "Usar el predeterminado",
  "state.loading": "Cargando…",
  "state.error": "No se pudieron cargar los datos",
  "state.empty": "Todavía no hay nada",
  "state.readOnly": "Solo lectura",
  "action.approve": "Aprobar",
  "action.reject": "Rechazar",
  "action.save": "Guardar",
  "action.saving": "Guardando…",
  "action.saved": "Guardado",
  "action.cancel": "Cancelar",
  "action.export": "Exportar a Excel",
};
export default es;
